// Libraries
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { PaginationComponent } from './pagination.component';

/**
 * `PaginationModule` defines a module manage pagination.
 */
@NgModule({
  declarations: [
    PaginationComponent,
  ],
  exports: [
    PaginationComponent
  ],
  imports: [
    CommonModule
  ],
  providers: [
  ]
})
export class PaginationModule {}
